import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Button} from 'reactstrap';
import {Translate} from 'react-localize-redux';
import './style.css';
import CategoryDialog from "../../../CategoryDialog/index";
import {
    ACTIONS,
    loadCategories,
    addCategory,
    deleteCategory,
    updateCategory,
    swapCategories,
} from "../../../../01-actions/adminCategories";
import Alert from '../../../../03-components/Alert';
import CategoryList from "../../../../03-components/CategoryList/index";

const menu = [
    {
        title: "Add child",
    },
    {
        title: "Edit",
    },
    {
        title: "Remove",
    },
];


class CategoriesPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            alertAck: true,
            openDialog: false,
            dialogOptions: null,
        };
        props.loadCategories();
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.handleCategoryDialog = this.handleCategoryDialog.bind(this);
    }

    handleCategoryDialog(options, values) {
        //-- dispatch the correct actions
        this.setState({openDialog: false, alertAck: false});

        if (options && options.editMode) {
            //-- update
            this.props.updateCategory({
                _id: options.category._id,
                parentId: values.parentCategory,
                name: values.categoryName
            });
        } else {
            //-- create new
            this.props.addCategory({
                value: values.categoryName,
                parent: values.parentCategory
            });
        }

    }

    handleMenuClick(menuItemIndex, value) {
        switch (menuItemIndex) {
            case 0:
                this.setState({dialogMode: 'add', addParentCategory: value, addDialogVisible: true});
                break;
            case 1:
                this.setState({dialogMode: 'edit', editCategory: value, addDialogVisible: true});
                break;
            case 2:
                this.setState({removeDialogVisible: true, removeCategoryCandidate: value});
                break;
            default:
                break;
        }
    }

    openMainDialog(visible, options) {
        return () => {
            this.setState({openDialog: visible, dialogOptions: options});
        }
    }

    render() {
        return (
            <Translate>
                {({translate}) =>
                    <div className="pages-admin-categories">
                        <div className="header">Categories</div>
                        <div className="content">
                            <Button
                                className={this.props.status === ACTIONS.CATEGORY_ADDING ? "progress-button" : ""}
                                disabled={this.props.status === ACTIONS.CATEGORY_ADDING}
                                color="primary"
                                onClick={this.openMainDialog(true)}>Add category</Button>

                            <div className="margin-bottom-20px"/>
                            <CategoryList
                                onSwap={(id1, id2) => {
                                    this.props.swapCategories({id1, id2});
                                }}
                                onMenuSelected={(index, item) => {
                                    switch (index) {
                                        case 0:
                                            this.setState({
                                                openDialog: true,
                                                dialogOptions: {
                                                    editMode: false,
                                                    category: {
                                                        parentId: item._id
                                                    }
                                                }
                                            });
                                            break;
                                        case 1:
                                            this.setState({
                                                openDialog: true,
                                                dialogOptions: {
                                                    editMode: true,
                                                    category: item
                                                }
                                            });
                                            break;
                                        case 2:
                                            this.setState({
                                                alertAck: false,
                                                showRemoveConfirm: true,
                                                removeItemId: item._id
                                            });
                                            break;
                                        default:
                                            break;
                                    }

                                }}
                                menu={menu} list={this.props.categories}/>

                            {(this.state.openDialog) &&
                            <CategoryDialog
                                onOK={this.handleCategoryDialog}
                                onClose={this.openMainDialog(false)}
                                options={this.state.dialogOptions}/>
                            }

                            {!this.state.alertAck && this.props.error &&
                            <Alert
                                okTitle={translate("ok")}
                                onOK={() => {
                                    this.setState({alertAck: true})
                                }}
                                header={translate("error")}
                                content={translate("errors." + this.props.error.code)}/>
                            }

                            {!this.state.alertAck && this.state.showRemoveConfirm &&
                            <Alert
                                type="danger"
                                cancelTitle={translate("cancel")}
                                okTitle={translate("ok")}
                                onClose={() => {
                                    this.setState({alertAck: true, showRemoveConfirm: false});
                                }}
                                onOK={() => {
                                    this.setState({alertAck: true, showRemoveConfirm: false});
                                    this.props.deleteCategory({
                                        _id: this.state.removeItemId
                                    });
                                }}
                                header={translate("confirm")}
                                content={translate("remove-category-confirm")}/>
                            }
                        </div>
                    </div>
                }
            </Translate>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        status: store.adminCategories.status,
        categories: store.adminCategories.categories,
        error: store.adminCategories.error,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({loadCategories, addCategory, updateCategory, deleteCategory, swapCategories}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesPage);



// WEBPACK FOOTER //
// ./src/04-containers/_pages/Admin/Categories/index.js